module.exports = __webpack_public_path__ + "img/profile_box_interests.9fca1c12.svg";